import React from "react";
import "./card/CardText";

export default function TextTitle(props) {

  return (
    <div 
    style={{
      color: "white",
      backgroundColor: "black",
      textAlign: "center",
      overflow: "hidden",
      padding: "1vw 1vw"
    }}>
       {props.textTitle.split("\r\n\r\n").map((p, i) => (
        <div
          key={i}
          style={{
            color:  "white",
            fontWeight: "bold",
            fontSize: i===0 ? "20px": props.isMobile ? "12px" : "15px",
            textAlign: "center",
            padding: props.isMobile? "5vw 10vw":"2vw 10vw",
            //textDecorationLine: i===0 ?"underline": "none",
          }}
        >
        {p}
        <br/>
      </div>
      ))}
        <i
              style={{
                height: "20px",
                width: "20px",
                backgroundColor: "#d8e2eb",
                borderRadius: "50%",
                display: "inline-block",
              }}
            />
    </div>
  );
}
